<template>
  <div class="privacy-page">
    <!-- Page Header -->
    <div class="page-header">
      <div class="section-container">
        <h1 class="page-header__title">Kebijakan Privasi</h1>
        <div class="page-header__breadcrumb">
          <router-link to="/">Home</router-link>
          <span>/</span>
          <span>Kebijakan Privasi</span>
        </div>
      </div>
    </div>

    <!-- Privacy Content -->
    <section class="section">
      <div class="section-container">
        <div class="privacy-content animate-on-scroll">
          <div class="privacy-card">
            <p class="intro">Kami berkomitmen untuk melindungi privasi anda. Kebijakan privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi pribadi yang anda berikan saat menggunakan aplikasi kami.</p>

            <h3>Informasi yang Dikumpulkan</h3>
            <p>Kami mengumpulkan informasi pribadi yang anda berikan saat registrasi awal, seperti:</p>
            <ul>
              <li>Nama lengkap</li>
              <li>Alamat email</li>
              <li>Nomor telepon</li>
              <li>Informasi lain yang relevan dengan layanan kami</li>
            </ul>
            <p>Kami juga dapat mengumpulkan data anonim yang tidak dapat digunakan untuk mengidentifikasi anda secara pribadi. Data ini digunakan untuk analisis statistik dan meningkatkan layanan kami.</p>

            <h3>Penggunaan Informasi</h3>
            <p>Informasi yang kami kumpulkan digunakan untuk:</p>
            <ul>
              <li>Mengelola akun anda</li>
              <li>Memberikan dukungan dan layanan pelanggan</li>
              <li>Mengirimkan pembaruan penting terkait aplikasi</li>
              <li>Meningkatkan fitur dan layanan aplikasi</li>
              <li>Melakukan analisis statistik menggunakan data anonim untuk meningkatkan kinerja dan pengalaman pengguna</li>
              <li>Memantau dan meningkatkan layanan kami</li>
            </ul>

            <h3>Keamanan Informasi</h3>
            <p>Kami menerapkan langkah-langkah keamanan yang sesuai untuk melindungi data pribadi anda. Namun, tidak ada metode transmisi data melalui internet yang 100% aman, dan kami tidak dapat menjamin keamanan absolut.</p>

            <h3>Berbagi Informasi</h3>
            <p>Kami tidak akan membagikan informasi pribadi anda kepada pihak ketiga kecuali jika diwajibkan oleh hukum atau dengan persetujuan anda.</p>

            <h3>Perubahan Kebijakan Privasi</h3>
            <p>Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Setiap perubahan akan diumumkan di aplikasi.</p>

            <div class="privacy-contact">
              <p>Jika anda memiliki pertanyaan terkait kebijakan privasi ini, silakan hubungi kami di <a href="mailto:info@miraverse.id">info@miraverse.id</a></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPage',
  mounted() {
    this.initScrollAnimations()
  },
  methods: {
    initScrollAnimations() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { entry.target.classList.add('animated') }
          })
        },
        { threshold: 0.1 }
      )
      this.$nextTick(() => {
        document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el))
      })
    }
  }
}
</script>

<style scoped lang="scss">
.privacy-content {
  max-width: 800px;
  margin: 0 auto;
}

.privacy-card {
  background: #fff;
  border-radius: 20px;
  padding: 48px;
  box-shadow: 0 4px 24px rgba(108, 41, 115, 0.08);
  border: 1px solid rgba(108, 41, 115, 0.06);

  .intro {
    font-size: 1.05rem;
    color: $text-body;
    line-height: 1.8;
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(108, 41, 115, 0.08);
  }

  h3 {
    margin-top: 28px;
    margin-bottom: 12px;
    font-size: 1.2rem;
    color: $text-dark;
  }

  p {
    color: $text-body;
    line-height: 1.8;
    margin-bottom: 12px;
  }

  ul {
    padding-left: 20px;
    margin-bottom: 16px;

    li {
      color: $text-body;
      margin-bottom: 8px;
      line-height: 1.6;
      position: relative;

      &::marker {
        color: #C73468;
      }
    }
  }
}

.privacy-contact {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(108, 41, 115, 0.08);

  a {
    color: #6C2973;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      color: #C73468;
    }
  }
}

@media (max-width: 576px) {
  .privacy-card {
    padding: 28px 20px;
  }
}
</style>